import { Component, Input, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { CommonProps } from '~app/modules/catalog/models';
import { select, Store } from '@ngrx/store';
import { getCategory } from '~app/modules/generic/store';
import { takeUntil } from 'rxjs/operators';
import { CatalogState } from '~app/modules/catalog/store';
import { Observable, Subject } from 'rxjs';
import { Category } from '~app/modules/generic/models';
import { StoryblokComponent } from 'storyblok-js-client';

@Component({
  selector: 'app-category-products-catalog-wrapper',
  templateUrl: './category-products-catalog-wrapper.component.html',
  styleUrls: ['./category-products-catalog-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoryProductsCatalogWrapperComponent implements OnInit, OnDestroy {
  @Input() categoryProps: CommonProps = {} as CommonProps;
  @Input() hidePageTitle: boolean = true;
  @Input() isMobile: boolean;
  @Input() set catalogContent(value: Array<StoryblokComponent<string>>) {
    this._catalogContent = value[0];
  }
  selectedCategory$: Observable<Category>;
  private unsubscribe$ = new Subject();
  private _catalogContent: StoryblokComponent<string>;

  get catalogSeoContent(): StoryblokComponent<string> {
    return this._catalogContent;
  }

  constructor(private store$: Store<CatalogState>) {}

  ngOnInit(): void {
    this.initializeSelectedCategory();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private initializeSelectedCategory(): void {
    this.selectedCategory$ = this.store$.pipe(select(getCategory), takeUntil(this.unsubscribe$));
  }
}
